import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { UrlRequestService } from './url-request.service';

@Injectable({ providedIn: 'root' })
export class AssetResource extends UrlRequestService {
  getAsset(assetId: string, token: string) {
    return this.downloadResourceWithRetries(assetPath(assetId), {
      headers: { 'X-Kaguya-Token': 'Bearer ' + token },
    });
  }
}

export function assetPath(assetId: string) {
  return `${environment.assetServiceBaseUrl}/api/v1/assets/${assetId}`;
}
